module.exports = "<style>body {\n  padding: 0;\n  margin: 0;\n}\n#viewer {\n  background-color: #000;\n  color: #fff;\n  margin: 0px;\n  padding: 0;\n  overflow: hidden;\n}</style><div id=viewer></div>";
